import { NavLink, useLocation } from 'react-router-dom';
import { useFeatureFlagEnabled } from 'posthog-js/react';

const NavigationStyles =
  'border-none rounded-xl shadow-none group flex justify-start items-center px-2 py-2  font-normal text-sm';

export const SettingsSidebar = () => {
  const location = useLocation();
  const isSettingsEnabled = useFeatureFlagEnabled('settings-integrations');

  const generalSettings = [
    {
      name: 'Integrations',
      to: `/settings/integrations`,
      show: isSettingsEnabled,
    },
    // {
    //   name: 'Data Catalog',
    //   to: `/settings/data-catalog`,
    // },
    {
      name: 'User Management',
      to: `/settings/user-management`,
      show: true,
    },
  ];

  const personalSettings = [
    {
      name: 'My Profile',
      to: `/settings/my-profile`,
    },
  ];

  const currentPathname = window.location.pathname;

  const isLinkActive = (linkText) => {
    return location.pathname.includes(`settings/${linkText}`);
  };
  return (
    <div className="flex flex-col bg-white h-full pt-2">
      <h2 className="text-brand-ai-200  font-medium leading-7 text-lg">
        Settings
      </h2>
      <div className="flex flex-col gap-6">
        <div className="flex flex-col gap-6 mt-6">
          {/* <h3 className=" font-medium text-sm text-brand-ai-200 leading-5">
            General Settings
          </h3> */}
          <div className="flex flex-col gap-1">
            {generalSettings?.map((item, index) => (
              <>
                {item.show && (
                  <NavLink
                    end={index === 0}
                    key={item.name}
                    to={item.to}
                    style={{ textDecoration: 'none' }}
                    className={({ isActive }) =>
                      `${NavigationStyles} ${
                        isActive ||
                        location.pathname.includes(
                          `settings/${item.name.toLowerCase()}/`
                        ) ||
                        location.pathname === item.to
                          ? 'text-brand-ai-200 bg-brand-chat-400'
                          : 'text-brand-ai-gray-300'
                      } hover:text-brand-ai-200 hover:bg-brand-chat-400 rounded-lg text-xs w-full`
                    }
                  >
                    {item.name}
                  </NavLink>
                )}
              </>
            ))}
          </div>
        </div>
        {/* <div className="flex flex-col gap-6">
          <h3 className=" font-medium text-sm text-brand-ai-200 leading-5">
            Personal Settings
          </h3>
          <div className="flex flex-col gap-2">
            {personalSettings?.map((item, index) => (
              <NavLink
                end={index === 0}
                key={item.name}
                to={item.to}
                style={{ textDecoration: "none" }}
                className={({ isActive }) =>
                  isActive || isLinkActive(item.to)
                    ? `${NavigationStyles} hover:text-brand-ai-200  hover:bg-brand-ai-700 text-black bg-brand-ai-700 w-full`
                    : `${NavigationStyles} bg-transparent text-brand-ai-gray-100 hover:text-brand-ai-200 hover:bg-brand-ai-700 w-full`
                }
              >
                <div className="flex items-center">{item.name}</div>
              </NavLink>
            ))}
          </div>
        </div> */}
      </div>
    </div>
  );
};
